import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

import { NoDialog } from "../NoDialog"
import { Dialog } from "../Dialog"
import { BackButton } from "../BackButton"

import styles from "./styles.module.scss"

import { chatSelector } from "utils/store/selectors/chat"
import { useTabletOrMobile } from "utils/hooks"
import { AppDispatch } from "utils/store/store"
import { setActiveChatId } from "utils/store/slices"
import { Text } from "ui-kit/components-branded"

export function DialogSide() {
    const { activeChatId, chats } = useSelector(chatSelector)
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()
    const isTabletOrMobile = useTabletOrMobile()
    const activeChat = chats.find((chat) => chat.chatId === activeChatId)

    const handleClickButton = function () {
        dispatch(setActiveChatId(0))
        navigate("/chat", { replace: true })
    }

    return (
        <div className={styles.container}>
            {isTabletOrMobile && (
                <div className={styles.header} onClick={handleClickButton}>
                    <BackButton />
                    <div className={styles.chatNameWrapper}>
                        <div className={styles.chatName}>
                            <Text size="h5" weight="medium" textOverflowShort>
                                {activeChat?.name ?? "Новый чат"}
                            </Text>
                        </div>
                    </div>
                </div>
            )}
            {activeChatId ? (
                <div className={styles.chatDialog}>{activeChatId && <Dialog />}</div>
            ) : (
                <NoDialog />
            )}
        </div>
    )
}
